export default "__VITE_ASSET__b2b365f7__"